import { Component, OnInit } from '@angular/core';
import { RoblexCollapsedSidepanelRef } from '../../../config/collapsed-sidepanel/collapsed-sidepanel.ref';

@Component({
    selector: 'roblex-collapsed-sidepanel-content',
    templateUrl: './collapsed-sidepanel-content.component.html',
    styleUrls: ['./collapsed-sidepanel-content.component.scss'],
})
export class CollapsedSidepanelContentComponent implements OnInit {
    /**
     * Creates an instance of collapsed sidepanel content component.
     * @param roblexCollapsedSidepanelRef RoblexCollapsedSidepanelRef
     */
    constructor(
        private roblexCollapsedSidepanelRef: RoblexCollapsedSidepanelRef
    ) {}
    /**
     * on init
     */
    ngOnInit(): void {}
    /**
     * Determines whether click closed on
     */
    onClickClosed() {
        this.roblexCollapsedSidepanelRef.close();
    }
}
